import { getConfig } from '@fshr/shared-react';
import type { Booking } from './types';

/** Ported from the legacy `getBookingItineraryPath` (libs/shared-old), minus its dependency on
 * `getConfig(process.env)` for `STATIC_SITE_URL` - the host now passes that in as `staticSiteUrl`
 * since env config isn't something this widget should reach into libs/env for. */
export default function getBookingItineraryPath({
	locale,
	activeBooking,
	bookings,
	isSignedIn,
}: {
	locale: string;
	activeBooking?: Booking | null;
	bookings: Booking[];
	isSignedIn: boolean;
}): string | undefined {
	const { STATIC_SITE_URL } = getConfig();
	if (!activeBooking && bookings.length === 0) {
		return undefined;
	}

	if (!activeBooking && bookings.length > 1) {
		const path = [locale !== 'en' && locale, 'profile', 'my-stays'].filter(Boolean).join('/');
		return `${STATIC_SITE_URL}/${path}`;
	}

	const booking = activeBooking || bookings[0];
	const hotelCode = booking?.hotelProducts?.[0]?.hotelCode;
	const reservationId = booking?.hotelProducts?.[0]?.reservationId;

	if (!hotelCode || !reservationId) return undefined;

	return `${STATIC_SITE_URL}/${[
		locale !== 'en' && locale,
		isSignedIn && 'profile',
		isSignedIn && 'my-stays',
		!isSignedIn && 'upcoming-trip',
		hotelCode,
		reservationId,
		'#itinerary',
	]
		.filter(Boolean)
		.join('/')}`;
}
